import React from 'react';
import DetailSection from '@components/v2/DetailSection';
import RelatedItems from '@components/v2/RelatedItems';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { namespace } from '../constants';
import CreateOptionsButton from './CreateOptionsButton';
import CollectOptionsButton from './CollectOptionsButton';
function RelatedItemsSection({ proposal, onRequestAddNote }) {
    return (React.createElement(DetailSection, { title: translate('tabs.detail.related', { namespace }) },
        React.createElement(RelatedItems, { items: proposal.relatedItems.map((item) => ({
                label: item.name,
                labelClass: item.icon,
                items: item.items.map((relatedItem) => ({
                    display: relatedItem.label,
                    path: relatedItem.path
                }))
            })), additionalActions: [
                React.createElement(CreateOptionsButton, { key: "create", proposal: proposal }),
                React.createElement(Button, { variant: "secondary", key: "note", onClick: onRequestAddNote },
                    React.createElement("i", { className: "fa-light fa-note" }),
                    " ",
                    translate('note', { namespace })),
                ...(proposal.proposalRequest ? [] : [React.createElement(CollectOptionsButton, { key: "collect", proposal: proposal })])
            ] })));
}
export default RelatedItemsSection;
